<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

<div class="header-container">
  <div class="logo-container">
    <a class="logo" href="#" (click)="navigateHome()"><img src="../../../../assets/images/logo.png"></a>    
  </div>
  
  <nb-actions size="large">
    <nb-action >Supplier Sourcing</nb-action>
  </nb-actions>
</div>

<div class="header-container">
  <nb-actions size="large">
    <nb-action >Welcome {{user.firstName}} {{user.lastName}}</nb-action>
    <nb-action ><a class="logoutMenu"  (click)="logout()">Logout</a> </nb-action>

  </nb-actions>
</div>
